import {Button, Checkbox, Col, Divider, Form, Input, Row, Select, Switch} from "antd";
import {EnterOutlined, MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {useContext} from "react";
import UserContext from "../../../context/users";
import {AdminRole} from "../../../constants";

export default function TriggerFormItems({properties}) {
  const [user] = useContext(UserContext);

  return (
    <>
      <Row gutter={[12, 12]}>
        <Col span={user.role === AdminRole ? 9 : 14}>
          <Form.Item name={['args', 'name']}
                     rules={[
                       {
                         required: true,
                         message: "O nome é obrigatório"
                       },
                       {
                         pattern: /^[a-zA-Z0-9_-]{1,64}$/,
                         message: 'O nome da função não pode ter espaços ou caracteres especiais',
                       }
                     ]}
                     label={'Nome da função'}>
            <Input placeholder={'consulta_clima'}/>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item valuePropName="checked"
                     name={'isActive'}
                     initialValue={true}
                     label={'Ativo'}>
            <Switch/>
          </Form.Item>
        </Col>
        {user.role === AdminRole && <Col>
          <Form.Item valuePropName="checked"
                     name={'copilotOnly'}
                     tooltip={'Se desativado este gatilho vai funcionar quando a flag copilot for false, se ativado funciona quando a flag copilot for true.'}
                     initialValue={false}
                     label={'Copiloto'}>
            <Switch/>
          </Form.Item>
        </Col>}
        <Col>
          <Form.Item valuePropName="checked"
                     initialValue={true}
                     tooltip={"Se desativado o assistente vai deixar de interpretar a resposta e responder apenas com gatilhos sem texto."}
                     name={'interpretResponse'}
                     label={'Interpretar'}>
            <Switch/>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item tooltip={'Você deve descrever o que essa função faz'}
                 name={['args', 'description']}
                 rules={[
                   {required: true, message: "A descrição é obrigatória"},
                   {max: 350, message: 'A descrição deve ter no máximo 350 caracteres'}
                 ]}
                 label={'Descrição'}>
        <Input.TextArea placeholder={'Função para consultar o clima...'} autoSize   count={{
          show: true,
          max: 350,
        }}/>
      </Form.Item>
      <Divider>Parametros</Divider>
      <FormParams properties={properties} name={['args', 'parameters', 'properties']}/>
      <Form.Item style={{display: "none"}}>
        <Button type="primary" htmlType="submit">Salvar</Button>
      </Form.Item>
    </>
  )
}

function FormParams(props) {
  return (
    <Form.List {...props}>
      {(fields, {add, remove}) => (<>
        {fields.map((field, index) => (<Form.Item
          required={true}
          style={{marginBottom: 0, width: '100%'}}
          key={field.key}
        >
          <Row gutter={[12, 12]}>
            <Col span={12}>
              <Form.Item
                noStyle
                {...field}
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: "Digite um nome ou delete o parametro",
                  },
                  {
                    pattern: /^[a-zA-Z0-9_-]{1,64}$/,
                    message: 'O nome do parametro não pode ter espaços ou caracteres especiais',
                  }
                ]}
                name={[field.name, 'name']}
              >
                <Input placeholder={'Nome da cidade'}/>
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item noStyle dependencies={[[props.name, field.name, 'type']]}>
                {({getFieldValue}) => {
                  const typeValue = getFieldValue([...props.name, field.name, 'type']);
                  return (
                    <Row gutter={[12, 12]}>
                      <Col span={typeValue === 'array' ? 12 : 24}>
                        <Form.Item
                          noStyle
                          {...field}
                          name={[field.name, 'type']}
                          initialValue="string"
                          validateTrigger={['onChange', 'onBlur']}
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message: 'Escolha um tipo ou delete o parametro',
                            },
                          ]}
                        >
                          <Select
                            popupMatchSelectWidth={false}
                            options={[
                              {label: 'Texto', value: 'string'},
                              {label: 'Inteiro', value: 'number'},
                              {label: 'Lista', value: 'array'},
                            ]}
                          />
                        </Form.Item>
                      </Col>
                      {typeValue === 'array' && (
                        <Col span={12}>
                          <Form.Item
                            noStyle
                            {...field}
                            name={[field.name, 'items', 'type']}
                            initialValue="string"
                            validateTrigger={['onChange', 'onBlur']}
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message: 'Escolha um tipo para a lista',
                              },
                            ]}
                          >
                            <Select
                              popupMatchSelectWidth={false}
                              options={[
                                {label: 'Texto', value: 'string'},
                                {label: 'Inteiro', value: 'number'},
                              ]}
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  );
                }}
              </Form.Item>
            </Col>
            <Col span={2}>
              <Button onClick={() => remove(field.name)} icon={<MinusCircleOutlined/>}/>
            </Col>
            <Col span={22}>
              <Form.Item
                noStyle
                {...field}
                validateTrigger={['onChange', 'onBlur']}
                rules={[{
                  required: true,
                  whitespace: true,
                  message: "Adicione uma descrição ou remova o campo",
                }]}
                name={[field.name, 'description']}
              >
                <Input.TextArea placeholder="Representa a cidade do qual o clima será consultado."
                                autoSize
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                {...field}
                noStyle
                validateTrigger={['onChange', 'onBlur']}
                name={[field.name, 'required']}
                valuePropName="checked"
              >
                <Checkbox>Obrigatório</Checkbox>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                {...field}
                noStyle
                validateTrigger={['onChange', 'onBlur']}
                name={[field.name, 'limitOptions']}
                valuePropName="checked"
              >
                <Checkbox>Limitar Opções</Checkbox>
              </Form.Item>
            </Col>
            <Col span={24}>
              {props?.properties?.length > 0 && Boolean(props?.properties[index]?.limitOptions) &&
                <Form.Item
                  {...field}
                  noStyle
                  rules={[{
                    required: true,
                    message: "É obrigatório adicionar pelo menos uma opção.",
                  }]}
                  validateTrigger={['onChange', 'onBlur']}
                  name={[field.name, 'enum']}>
                  <Select
                    mode="tags"
                    open={false}
                    maxCount={45}
                    suffixIcon={<EnterOutlined/>}
                    placeholder="Digite uma opção e dê enter em seguida"
                  />
                </Form.Item>
              }
            </Col>
            {index < fields.length - 1 && <Divider/>}
          </Row>
        </Form.Item>))}
        <Form.Item style={{margin: '1rem 0'}}>
          <Button
            type="dashed"
            onClick={() => {
              add({type: "string"});
            }}
            icon={<PlusOutlined/>}
          >
            Adicionar Parametro
          </Button>
        </Form.Item>
      </>)}
    </Form.List>
  )
}

